import * as React from 'react';
const s = require('./NonLoggedBG.scss') as {
  root: string;
  image: string;
};

export interface NonLoggedBGProp {
  className: string;
  children: React.ReactNode;
}

export abstract class NonLoggedBG extends React.Component<NonLoggedBGProp, undefined> {
}

export class BuetzerBuebeNonLoggedBG extends NonLoggedBG {
  render() {
    return (
      <div className={s.root + ' ' + this.props.className}>
        <div className={s.image}>
          {this.props.children}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/themes/buetzerBuebeTheme/components/NonLoggedBG/BuetzerBuebeNonLoggedBG.tsx